<template>
  <div class="lobby-container">
    <div class="lobby-card">
      <h3 style="margin: 0">Toepen</h3>
      <p class="subtitle">Join a room and start playing</p>

      <div class="lobby-input">
        <div class="lobby-input-field fields">
          <input v-model="userName" placeholder="Enter your username" />
          <input v-model="roomId" placeholder="Enter room name" />
        </div>
        <div class="lobby-input-field buttons">
          <button @click="createRoom">Create Room</button>
          <button @click="joinRoom" class="join">Join Room</button>
        </div>
      </div>

      <h3>Available Rooms</h3>
      <ul v-if="rooms.length > 0">
        <li v-for="room in rooms" :key="room">
          <button @click="joinExistingRoom(room)">{{ room }}</button>
        </li>
      </ul>
      <p v-else>No rooms available</p>

      <p>{{ status }}</p>
    </div>
  </div>
</template>
  
<script>
import storage from '@/utility/storage.js'
import { v4 as uuidv4 } from 'uuid'
import { SocketManager } from '@/utility/SocketManager.js'

export default {
  inject: ['socket'],
  data() {
    return {
      socketManager: null,
      roomId: null,
      status: '',
      playerId: storage.get('playerId') || uuidv4(),
      rooms: [],
    }
  },
  methods: {
    createRoom() {
      if (!this.roomId || !this.userName) {
        this.status = 'Please enter valid room and username'
        return
      }

      storage.set('userName', this.userName)
      this.socketManager.emitSocketEvent('createRoom', {
        roomId: this.roomId,
        userName: this.userName,
        playerId: this.playerId,
      })
    },
    joinRoom() {
      if (!this.roomId || !this.userName) {
        this.status = 'Please enter valid room and username'
        return
      }
      storage.set('userName', this.userName)
      this.socketManager.emitSocketEvent('joinRoom', {
        roomId: this.roomId,
        userName: this.userName,
        playerId: this.playerId,
      })
    },
    joinExistingRoom(roomId) {
      if (!this.userName) {
        this.status = 'Please enter valid room and username'
        return
      }

      storage.set('userName', this.userName)
      this.socketManager.emitSocketEvent('joinRoom', {
        roomId: roomId,
        userName: this.userName,
        playerId: this.playerId,
      })
    },
  },
  mounted() {
    this.socketManager = new SocketManager(this.socket)

    storage.set('playerId', this.playerId)
    this.socketManager.emitSocketEvent('getRooms')

    this.socketManager.onSocketEvent('connect', () => {
      console.log('Connected to the server!')
      this.socketManager.emitSocketEvent('getRooms')
    })

    this.socketManager.onSocketEvent('roomCreated', (roomId) => {
      this.status = `Room '${roomId}' created!`
      this.$router.push({ path: `/room/${roomId}` })
    })

    // Listen for room updates
    this.socketManager.offSocketEvent('updateRooms')

    this.socketManager.onSocketEvent('updateRooms', (rooms) => {
      this.rooms = rooms
    })
    this.socketManager.onSocketEvent('roomExists', (roomId) => {
      console.log('Room exists')
      this.status = `Room '${roomId}' already exists.`
    })
    this.socketManager.onSocketEvent('roomJoined', (roomId) => {
      this.status = `Joined room '${roomId}'!`
      this.$router.push({
        path: `/room/${roomId}`,
      })
    })
  },
  beforeUnmount() {
    this.socketManager.offSocketEvent('connect')
    this.socketManager.offSocketEvent('roomCreated')
    this.socketManager.offSocketEvent('roomExists')
    this.socketManager.offSocketEvent('roomJoined')
  },
}
</script>

<style scoped>
/* Remove default list styling and make it scrollable */
ul {
  list-style: none; /* Remove bullet points */
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 300px; /* Optional: Set a max width */
  max-height: 200px; /* Set a max height for scrolling */
  overflow-y: auto; /* Enable vertical scrolling */
  border: 1px solid #ccc; /* Optional: Add border for clarity */
  border-radius: 5px;
  padding: 10px;
  background: #f9f9f9; /* Light background for contrast */
}

/* Style the scrollbar (WebKit-based browsers) */
ul::-webkit-scrollbar {
  width: 6px; /* Narrow scrollbar */
}

ul::-webkit-scrollbar-thumb {
  background: #888; /* Color of scrollbar */
  border-radius: 3px;
}

ul::-webkit-scrollbar-thumb:hover {
  background: #555; /* Darker on hover */
}

/* Style the list items */
li {
  margin-bottom: 5px;
}

/* Card-like container */
.lobby-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 60%;
  padding: 10px;
}

/* Title */
.lobby-card h1 {
  font-size: 0.8rem;
  color: #333;
  margin-bottom: 10px;
}

/* Subtitle */
.subtitle {
  font-size: 0.8rem;
  color: #666;
}

/* Inputs */
.lobby-card input {
  width: 100%;
  padding: 0.6rem;
  font-size: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  max-width: 300px;
}

.lobby-card button.join {
  background-color: #3498db; /* Blue - Alternative option */
}

.lobby-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.lobby-input-field {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.lobby-input-field.fields {
  width: 55%;
}

.lobby-input-field.buttons {
  width: 30%;
}

@media screen and (min-width: 1000px) {
  .lobby-card {
    width: 50%;
  }

  .lobby-input {
    flex-direction: column;
    gap: 10px;
  }

  .lobby-input-field {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .lobby-input-field.buttons {
    width: 100%;
  }

  .lobby-input-field.fields {
    width: 100%;
  }
}
</style>
  